export default "__VITE_ASSET__02ff28f2__"